export default __webpack_public_path__ + "static/media/48.1f4c2b25.jpg";